<template lang='pug'>
  #card-totalizadores-laudos-dashboard
    .row.m-0
      .col-12
        el-skeleton(:rows='1' :loading='dadosGrafico.loading || dadosTabela.loading' animated)
          template(v-slot:template)
            .dashboard-laudos__grafico__tabela
              el-skeleton-item.dashboard-laudos__grafico__tabela--skeleton(variant="react")

          template
            .dashboard-laudos__grafico__tabela
              .dashboard-laudos__grafico__tabela--grafico(
                v-if='mostrarGrafico'
                :style='dadosGrafico.erro || (!dadosGrafico.payload || dadosGrafico.payload.itens.length === 0) ? "opacity: 0.7" : ""'
              )
                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-if='!dadosGrafico.payload || dadosGrafico.payload.itens.length === 0')
                  span {{ $t('mensagens.laudos.semDadosGraficoLinha') }}
                GraficoLinhasDashboard(
                  :series='dadosGrafico.payload.itens'
                  :categories='dadosGrafico.payload.colunas'
                )
              .dashboard-laudos__grafico__tabela--tabela(
                v-else
                :style='dadosTabela.erro || !dadosTabela.payload ? "opacity: 0.7" : ""'
              )
                div.w-100.h-100.justify-content-center.align-items-center.d-flex(v-if='!dadosTabela.payload || dadosTabela.payload.itens.length === 0')
                  span {{ $t('mensagens.laudos.semDadosTabela') }}

                TabelaDinamicaDashboardLaudos(
                  v-else
                  :payload='dadosTabela.payload'
                )

              .dashboard-laudos__grafico__tabela--footer
                BaseButton(
                  type='primary'
                  @click='buscarDadosGrafico'
                  style='font-size: 27px; padding: 3px; width: 45px; margin-right: 10px'
                  :style='styleButtonGrafico'
                )
                  i.lyra-grafico-em-linha(:style='styleIconeGrafico')

                BaseButton(
                  type='primary'
                  @click='buscarDadosTabela'
                  style='font-size: 27px; padding: 3px; width: 45px; margin-left: 10px'
                  :style='styleButtonTabela'
                )
                  i.lyra-grafico-em-barra(:style='styleIconeTabela')
</template>

<script>
import {GChart as GraficoColuna} from 'vue-google-charts/legacy';
import TabelaDinamicaDashboardLaudos from '@/views/laudos/dashboard/TabelaDinamicaDashboardLaudos.vue';
import GraficoLinhasDashboard from '@/views/laudos/dashboard/GraficoLinhasDashboard.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
  name: 'CardTotalizadoresLaudosDashboard',
  components: {
    GraficoColuna,
    GraficoLinhasDashboard,
    TabelaDinamicaDashboardLaudos,
    BaseButton
  },
  props: {
    dadosGrafico: {
      type: Object,
      required: true,
      default: () => ({
        loading: false,
        erro: false,
        payload: {
          colunas: [],
          itens: []
        }
      })
    },
    dadosTabela: {
      type: Object,
      required: true,
      default: () => ({
        loading: false,
        erro: false,
        payload: {
          colunas: [],
          itens: [],
          visualizar: false
        }
      })
    }
  },
  data: () => ({
    styleButtonGrafico: {
      backgroundColor: '#359138',
      borderColor: '#359138',
      color: '#fff'
    },
    styleButtonTabela: {
      backgroundColor: '#fff',
      borderColor: '#00413c',
      color: '#00413c'
    },
    styleIconeGrafico: {
      backgroundColor: '#fff',
      top: '3px',
      position: 'relative'
    },
    styleIconeTabela: {
      backgroundColor: '#00413c',
      top: '3px',
      position: 'relative'
    },
    mostrarGrafico: true
  }),
  methods: {
    buscarDadosTabela() {
      this.mostrarGrafico = false;
      this.styleButtonGrafico = {
        backgroundColor: '#fff',
        borderColor: '#00413c',
        color: '#00413c'
      };
      this.styleButtonTabela = {
        backgroundColor: '#359138',
        borderColor: '#359138',
        color: '#fff'
      };
      this.styleIconeGrafico = {
        backgroundColor: '#00413c',
        top: '3px',
        position: 'relative'
      };
      this.styleIconeTabela = {
        backgroundColor: '#fff',
        top: '3px',
        position: 'relative'
      };
    },
    buscarDadosGrafico() {
      this.mostrarGrafico = true;
      this.styleButtonGrafico = {
        backgroundColor: '#359138',
        borderColor: '#359138',
        color: '#fff'
      };
      this.styleButtonTabela = {
        backgroundColor: '#fff',
        borderColor: '#00413c',
        color: '#00413c'
      };
      this.styleIconeGrafico = {
        backgroundColor: '#fff',
        top: '3px',
        position: 'relative'
      };
      this.styleIconeTabela = {
        backgroundColor: '#00413c',
        top: '3px',
        position: 'relative'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
#card-totalizadores-laudos-dashboard {
  .dashboard-laudos__grafico__tabela {
    background: white;
    height: 600px;
    width: 100%;
    border-radius: 5px;
    overflow: hidden;

    .dashboard-laudos__grafico__tabela--grafico {
      height: 530px;
      overflow: hidden;
    }

    .dashboard-laudos__grafico__tabela--tabela {
      height: 530px;
      overflow-y: auto;
    }

    .dashboard-laudos__grafico__tabela--footer {
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .dashboard-laudos__grafico__tabela--skeleton {
    height: 100%;
    width: 100%;
    border-radius: 5px;
  }
}

.lyra-grafico-em-barra {
  content: '';
  width: 27px;
  height: 27px;
  display: inline-block;
  -webkit-mask: url(../../../assets/lyra-icons/svg/grafico-em-barra.svg) no-repeat 50% 50%;
  mask: url(../../../assets/lyra-icons/svg/grafico-em-barra.svg) no-repeat 50% 50%;
  mask-size: cover;
  -webkit-mask-size: cover;
  background-color: #00413c;
}

.lyra-grafico-em-linha {
  content: '';
  width: 27px;
  height: 27px;
  display: inline-block;
  -webkit-mask: url(../../../assets/lyra-icons/svg/grafico-em-linha.svg) no-repeat 50% 50%;
  mask: url(../../../assets/lyra-icons/svg/grafico-em-linha.svg) no-repeat 50% 50%;
  mask-size: cover;
  -webkit-mask-size: cover;
  background-color: #00413c;
}
</style>
